function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M19.81 18.13l-.65-1.65a13.29 13.29 0 01-.93-4.89V8.25a8.25 8.25 0 00-16.5 0v3.34a13.29 13.29 0 01-.93 4.9l-.65 1.64a2.18 2.18 0 002 3h4.4v.49a3.4 3.4 0 006.8 0v-.49h4.4a2.18 2.18 0 002-3zM11 21.6a1 1 0 11-2 0v-.49h2zm1.21-2.91H2.54l.52-1.32a15.7 15.7 0 001.1-5.78V8.25a5.83 5.83 0 0111.65 0v3.34a15.7 15.7 0 001.1 5.78l.52 1.32z",
  fill: "#90a1ba",
  "data-name": "Capa 6"
}));

var SvgNotificationBell = function SvgNotificationBell(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 19.96 25"
  }, props), _ref);
};

export default SvgNotificationBell;